import { nanoid } from "nanoid";
import { API_URL } from "../config/settings";
import { Headers } from "./Headers";

// export const uploadFile = (file) =>
//   S3FileUpload.uploadFile(
//     new File([file], file?.name || nanoid(), {
//       type: file?.type || "",
//       lastModified: file?.lastModified || new Date(),
//     }),
//     s3Credentials
//   )

export const uploadFile = async (file) => {
  let filename = file.name;
  filename = filename.split("%").join("").split(" ").join("");
  filename = `admin/${nanoid()}_${filename}`;
  
  // Use the old URL without v2 for file uploads
  const baseURL = API_URL
  const uploadUrl = `${baseURL}/admin/uploads/presigned-url`;
  const headers = Headers.get_auth();
  
  console.log("🔑 Upload URL:", uploadUrl);
  console.log("🔑 Headers:", headers);
  console.log("🔑 Token:", headers.Authorization);
  
  const response = await fetch(uploadUrl, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({ path: filename, mimeType: file?.type ?? "" }),
  });
  
  console.log("📡 Upload response status:", response.status);
  console.log("📡 Upload response ok:", response.ok);
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error("❌ Upload response error:", errorText);
    throw new Error(`Upload failed: ${response.status} - ${errorText}`);
  }
  
  // Log the full response to understand the structure
  const responseData = await response.json();
  console.log("📋 Full response data:", responseData);
  console.log("📋 Response type:", typeof responseData);
  console.log("📋 Response keys:", Object.keys(responseData || {}));
  
  // Check if result exists
  if (responseData.result) {
    console.log("✅ 'result' property exists:", responseData.result);
    console.log("📋 Result type:", typeof responseData.result);
    console.log("📋 Result keys:", Object.keys(responseData.result || {}));
  } else {
    console.log("❌ 'result' property does NOT exist");
    console.log("📋 Available properties:", Object.keys(responseData || {}));
  }
  
  const {
    payload: { presignedUrl, url },
  } = responseData;
  const response2 = await fetch(presignedUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file?.type ?? "" },
  });
  if (!response2.ok) throw new Error("Грешка");
  return { name: filename, location: url };
};

export const uploadFiles = async (files, special, dir) => await Promise.all([...files].map((file) => uploadFile(file, special, dir)));

// export const uploadFiles = (files) => {
//   const promises = [];
//   Array.from(files).forEach((f) =>
//     promises.push(
//       S3FileUpload.uploadFile(
//         new File([f], f?.name || nanoid(), {
//           type: f?.type,
//           lastModified: f?.lastModified || new Date(),
//         }),
//         s3Credentials
//       )
//     )
//   );
//   return Promise.all(promises);
// };
